import React from "react";
import { motion } from "framer-motion";
import CC1 from "../assets/CC1.png";
import CC2 from "../assets/CC2.jpeg";
import CC3 from "../assets/CC3.jpeg";

// import certificate from "../assets/certificate.png";
import "../styles/Certifications.css";

const certificationData = [
  {
    id: 1,
    logo: CC1,
  },
  {
    id: 2,
    logo: CC2,
  },
  {
    id: 3,
    logo: CC3,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6 },
  }),
};

const Certifications = () => {
  return (
    <>
      {/* Certifications */}
      <motion.section
        className="certifications-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        <h2 className="section-title">Our Certifications</h2>
        <p className="section-subtext">
          We proudly hold MBE and IDOA Certifications, enhancing our access to government contracts.
          <br /> Our Indianapolis Certificate of Women and Minority Business Development reflects our commitment to diversity.
        </p>
        <div className="certifications-list">
          {certificationData.map((cert, index) => (
            <motion.div
              key={cert.id}
              className="cert-card"
              custom={index}
              variants={fadeUp}
            >
              <img src={cert.logo} alt={cert.title} className="cert-logo" />
              <h3>{cert.title}</h3>
              <p>{cert.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Quality & Services */}
      <motion.section
        className="quality-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        custom={1}
      >
        <div className="centered-text">
          <h1 className="quality-heading">We Deliver Quality Results</h1>
          <p className="quality-content">
            A third-generation, family-owned firm, TMC Contractors has deep roots in the construction industry.
            <br />
            With refined strategies and four core service lines, we deliver unmatched quality—on time and on budget.
          </p>
        </div>

        <div className="services-grid">
          {["GC", "CM", "BD", "OR"].map((icon, i) => (
            <motion.div
              key={icon}
              className="service-card"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              custom={i}
              variants={fadeUp}
            >
              <img src={`${icon}.png`} alt={icon} />
              <p>
                {icon === "GC" && "GENERAL CONTRACTING"}
                {icon === "CM" && "CONSTRUCTION MANAGEMENT"}
                {icon === "BD" && "DESIGN-BUILD"}
                {icon === "OR" && "OWNER'S REPRESENTATIVE"}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Mission & Vision */}
      <motion.section
        className="info-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        custom={2}
      >
        <h2 className="section-title">Mission & Vision</h2>
        <div className="info-grid">
          <motion.div className="info-box" variants={fadeUp} custom={0}>
            <h2>Mission</h2>
            <p>
              TMC Contractors is operated by Kevin Thomas with over 30 years of experience in the construction industry.
              A minority-owned company performing concrete and general contracting in the Indianapolis and NW Indiana
              region. We are proud to be DBE, MBE, and WBE certified.
            </p>
          </motion.div>
          <motion.div className="info-box" variants={fadeUp} custom={1}>
            <h2>Vision</h2>
            <p>
              With capabilities scaling up to million-dollar projects, our team has served organizations including IDOT,
              IBM Construction, Gary School Corporation, and more. We aim to deliver excellence in both large-scale and
              community-centered initiatives.
            </p>
          </motion.div>
        </div>
      </motion.section>
    </>
  );
};

export default Certifications;
